export default function sortObjectsByProperty(arr, property) {
  return arr.sort((a, b) => {
    var _a$property, _b$property;
    const valueA = (_a$property = a[property]) === null || _a$property === void 0 ? void 0 : _a$property.toLowerCase();
    const valueB = (_b$property = b[property]) === null || _b$property === void 0 ? void 0 : _b$property.toLowerCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });
}